import React from 'react';

type Props = { color?: string };

const Mastercard = ({ color = 'white' }: Props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			version='1.1'
			xmlnsXlink='http://www.w3.org/1999/xlink'
			width='100%'
			height='100%'
			x='0'
			y='0'
			viewBox='0 0 512 512'
			xmlSpace='preserve'
		>
			<g>
				<path
					fill='#3c80ad'
					d='M7.9 256C7.9 119 119 7.9 256 7.9S504.1 119 504.1 256 393 504.1 256 504.1 7.9 393 7.9 256z'
					opacity='1'
					data-original='#3c80ad'
				></path>
				<path
					fill='#931b1d'
					d='M174.9 135.6C112.3 136 61.6 187 61.6 249.9c0 63.1 51.1 114.2 114 114.2 29.5 0 56.4-11.3 76.7-29.8 4.2-3.8 8-7.9 11.6-12.2h-23.4c-3.1-3.8-6-7.7-8.5-11.8h40.3c2.5-3.9 4.7-8 6.6-12.2h-53.6c-1.8-3.9-3.4-7.9-4.8-12h63.1c3.8-11.4 5.9-23.6 5.9-36.2 0-8.4-.9-16.6-2.6-24.5h-69.7c.9-4.1 2-8.1 3.2-12h63.1c-1.4-4.2-3.1-8.3-4.9-12.2h-53.4c1.9-4.1 4.1-8.1 6.5-12H272c-2.7-4.3-5.6-8.4-8.8-12.2h-22.4c3.5-4.1 7.3-8 11.4-11.5-20.3-18.5-47.2-29.8-76.7-29.8-.1-.1-.3-.1-.6-.1z'
					opacity='1'
					data-original='#931b1d'
				></path>
				<path
					fill='#f16622'
					d='M442.6 249.9c0 63.1-51 114.3-114 114.3s-114-51.1-114-114.2 51-114.3 114-114.3c62.9-.1 114 51 114 114.2 0-.1 0 0 0 0z'
					opacity='1'
					data-original='#f16622'
				></path>
				<path
					fill='#f7981d'
					d='M442.6 251.2c0 63.1-51 114.3-114 114.3s-114-51.1-114-114.2v-.1c0-63.1 51-114.3 114-114.3 62.9 0 114 51.1 114 114.3 0-.1 0-.1 0 0z'
					opacity='1'
					data-original='#f7981d'
				></path>
				<path
					fill='#cb2026'
					d='M174.9 136.9c-62.6.4-113.3 51.4-113.3 114.3 0 63.1 51.1 114.3 114 114.3 29.5 0 56.4-11.3 76.7-29.8 4.2-3.8 8-7.9 11.6-12.2h-23.4c-3.1-3.8-6-7.7-8.5-11.8h40.3c2.5-3.9 4.7-8 6.6-12.2h-53.6c-1.8-3.9-3.4-7.9-4.8-12h63.1c3.8-11.4 5.9-23.6 5.9-36.2 0-8.4-.9-16.6-2.6-24.5h-69.7c.9-4.1 2-8.1 3.2-12h63.1c-1.4-4.2-3.1-8.3-4.9-12.2h-53.4c1.9-4.1 4.1-8.1 6.5-12H272c-2.7-4.3-5.6-8.4-8.8-12.2h-22.4c3.5-4.1 7.3-8 11.4-11.5-20.3-18.5-47.2-29.8-76.7-29.8-.1-.2-.3-.2-.6-.2z'
					opacity='1'
					data-original='#cb2026'
				></path>
				<path
					fill='#ffffff'
					d='m216.6 280.3 1.5-10.3c-.8 0-2.1.4-3.1.4-4.2 0-4.7-2.2-4.4-3.9l3.4-21.1h6.4l1.5-11.4h-6.1l1.2-7.1h-12c-.3.3-7.2 40-7.2 44.8 0 7.2 4 10.4 9.7 10.3 4.5-.2 7.9-1.4 9.1-1.7zM220.5 260.5c0 17.2 11.3 21.3 21 21.3 8.9 0 12.8-2 12.8-2l2.1-11.7s-6.8 3-12.9 3c-13 0-10.7-9.7-10.7-9.7h24.7s1.6-7.9 1.6-11.1c0-8-4-17.8-17.3-17.8-12.3 0-21.3 13.1-21.3 28zm21.3-17.1c6.8 0 5.6 7.7 5.6 8.3h-13.5c0-.8 1.3-8.3 7.9-8.3zM318.6 280.3l2.2-13.3s-6 3-10 3c-8.6 0-12.1-6.6-12.1-13.7 0-14.4 7.4-22.3 15.7-22.3 6.2 0 11.1 3.5 11.1 3.5l2-12.9s-7.4-3-13.7-3c-14 0-27.7 12.2-27.7 35.1 0 15.2 7.4 25.2 21.9 25.2 4.1 0 10.6-1.6 10.6-1.6zM149.9 232.7c-8.3 0-14.7 2.7-14.7 2.7l-1.8 10.5s5.3-2.1 13.2-2.1c4.5 0 7.8.5 7.8 4.2 0 2.2-.4 3.1-.4 3.1s-3.6-.3-5.2-.3c-10.5 0-21.5 4.5-21.5 18 0 10.7 7.2 13.1 11.7 13.1 8.6 0 12.2-5.6 12.5-5.6l-.4 4.7h10.7l4.8-33.5c0-14.4-12.4-14.8-16.7-14.8zm2.6 27.2c.2 2.1-1.3 11.6-8.6 11.6-3.8 0-4.8-2.9-4.8-4.6 0-3.3 1.8-7.3 10.7-7.3 2.1 0 2.3.3 2.7.3zM177.9 281.5c2.7 0 18.4.7 18.4-15.5 0-15.1-14.5-12.1-14.5-18.2 0-3 2.4-4 6.7-4 1.7 0 8.3.6 8.3.6l1.5-10.7s-4.3-.9-11.2-.9c-9 0-18.1 3.6-18.1 15.9 0 13.9 15.2 12.5 15.2 18.4 0 3.9-4.2 4.2-7.5 4.2-5.7 0-10.8-1.9-10.8-1.9l-1.6 10.6c.3.1 3.4 1.5 13.6 1.5zM419.2 223l-2.6 16.3s-4.6-6.3-11.7-6.3c-11.1 0-20.4 13.4-20.4 28.9 0 10 4.9 19.7 15.1 19.7 7.3 0 11.3-5.1 11.3-5.1l-.5 4.3h11.8l9.3-57.8zm-5.6 31.8c0 6.4-3.2 15-9.8 15-4.4 0-6.4-3.7-6.4-9.4 0-9.4 4.2-15.7 9.6-15.7 4.3 0 6.6 3 6.6 10.1zM84.2 280.9l7.4-43.7 1.1 43.7h8.4l15.6-43.7-6.9 43.7h12.4l9.6-57.9h-19.2l-12 35.5-.7-35.5H82.2l-9.7 57.9zM271.2 281c3.5-20.1 4.2-36.5 12.6-33.5 1.5-7.8 2.9-10.8 4.5-14.1 0 0-.8-.2-2.3-.2-5.4 0-9.5 7.4-9.5 7.4l1.1-6.8h-11.3l-7.6 47.1h12.5zM346.7 232.7c-8.3 0-14.7 2.7-14.7 2.7l-1.8 10.5s5.3-2.1 13.2-2.1c4.5 0 7.8.5 7.8 4.2 0 2.2-.4 3.1-.4 3.1s-3.6-.3-5.2-.3c-10.5 0-21.5 4.5-21.5 18 0 10.7 7.2 13.1 11.7 13.1 8.6 0 12.3-5.6 12.4-5.6l-.4 4.7h10.7l4.8-33.5c0-14.4-12.3-14.8-16.6-14.8zm2.6 27.2c.2 2.1-1.3 11.6-8.6 11.6-3.8 0-4.7-2.9-4.7-4.6 0-3.3 1.8-7.3 10.7-7.3 2 0 2.2.3 2.6.3zM373.1 281c3.5-20.1 4.2-36.5 12.6-33.5 1.5-7.8 2.9-10.8 4.5-14.1 0 0-.8-.2-2.3-.2-5.4 0-9.5 7.4-9.5 7.4l1.1-6.8h-11.3l-7.6 47.1h12.5z'
					opacity='1'
					data-original='#ffffff'
				></path>
			</g>
		</svg>
	);
};

export default Mastercard;
